import * as signalR from "@microsoft/signalr";
import mitt from "mitt"

let connection = null;
const emitter = mitt();

const signalrClient = {
    async init(token) {
        if (connection) {
          await connection.stop();
        }

        connection = new signalR.HubConnectionBuilder()
            .withUrl(process.env.VUE_APP_SIGNAL_URL, {
                accessTokenFactory: () => token
            })
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Error)
            .build();


        connection.on('MensajeAdded', (mensaje) => {
            emitter.emit("mensaje-added", mensaje)
        })

        connection.onclose(() => console.warn("❌ SignalR desconectado"))

        try
        {
            await connection.start();
            console.log("✅ SignalR conectado");
        }
        catch(err) 
        {
            console.error("❌ Error conectando SignalR", err);
        }
    },

    stop() 
    {
        if (connection) return connection.stop();
        
        emitter.all.clear();
    },

    getConnection() {
        return connection;
    },

    // on: emmiter.on,
    // off: emmiter.off,
    // emit: emmiter.emit
};

export default signalrClient;
export const signalrEmitter = emitter;